import { VueCookieNext } from 'vue-cookie-next';

export const getCookie = (key: string): string => {
  return VueCookieNext.getCookie(key);
};

export const setCookie = (key: string, value: string): void => {
  VueCookieNext.setCookie(key, value);
};
